import { render } from "./FollowBtn.vue?vue&type=template&id=4ae843d4&scoped=true"
import script from "./FollowBtn.vue?vue&type=script&lang=js"
export * from "./FollowBtn.vue?vue&type=script&lang=js"

import "./FollowBtn.vue?vue&type=style&index=0&id=4ae843d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae843d4"]])

export default __exports__